// Placement lookup for the convention diploma page.
//
// The diploma cites the shooter's rank in their OPEN (non-championship)
// result section for one specific start — the same table and order the
// results page shows. Pure function over the resultList map produced by
// conventionResultStore.getResultsListForAllClasses.

export function findDiplomaPlacement(resultList, { userId, stageMd5 } = {}) {
    if (!resultList || !userId || !stageMd5) {
        return null;
    }
    let found = null;
    Object.keys(resultList).some(key => {
        const bucket = resultList[key];
        if (bucket.championship) {
            return false;
        }
        const participants = bucket.participants || [];
        const idx = participants.findIndex(participant => participant.id === userId
            && participant.stageMd5 === stageMd5);
        if (idx < 0) {
            return false;
        }
        const participant = participants[idx];
        found = {
            placement: participant.resultStatus ? null : idx + 1,
            totalParticipants: participants.filter(other => !other.resultStatus).length,
            totalScore: participant.totalScore,
            totalIx: participant.totalIx,
            resultStatus: participant.resultStatus || '',
            name: participant.name,
            sportsClub: participant.sportsClub || '',
            weaponClass: bucket.weaponClass,
            weaponDisplay: bucket.weaponDisplay,
            skillClass: bucket.skillClass || null,
            stageType: bucket.stageType,
            stageName: bucket.stageName || '',
            championship: bucket.championship || '',
        };
        return true;
    });
    return found;
}
